import React from 'react'
import { makeStyles, TableCell, TableRow, Typography } from '@material-ui/core'

export const useStyles = makeStyles(() => ({
  skipUppercase: {
    textTransform: 'none',
  },
  valueCell: {
    width: '20%',
    textAlign: 'center',
  },
  headerCell: {
    width: '60%',
  },
  nonHeaderCell: {
    borderBottom: 0,
  },
}))

type Props = {
  title: string
  values: (number | null)[]
  formatValue?: (value: number | null) => string
  isHeader?: boolean
}

export function SidebarTableRow({
  title,
  values,
  formatValue,
  isHeader,
}: Props): React.ReactElement {
  const classes = useStyles()

  return (
    <TableRow>
      <TableCell
        className={isHeader ? classes.headerCell : classes.nonHeaderCell}
      >
        {isHeader ? (
          <Typography variant="subtitle1" className={classes.skipUppercase}>
            {title}
          </Typography>
        ) : (
          title
        )}
      </TableCell>
      {values.map((value) => (
        <TableCell
          key={value}
          className={`${isHeader ? '' : classes.nonHeaderCell} ${
            classes.valueCell
          }`}
        >
          {formatValue ? formatValue(value) : value}
        </TableCell>
      ))}
    </TableRow>
  )
}
